enum UnsavedDataEnum {
    Query = "Query",
    HasUnsavedData = "HasUnsavedData"
}

export default UnsavedDataEnum;
